import styled from 'styled-components';
import { Avatar } from "@heroui/react";
import { RenderIf } from '@components/hoc';
import { capitalizeFirstLetter } from '../../../../../IRIS/utility';
import getNameInitials from '../../../../../../utility/getNameInitials';
import { UNIVERSITYPLAN } from '../../../../../../utility/enums/planType';

const ActivePlan = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 170px;
  padding: 0 20px;
  height: 32px;
  border-radius: 20px;
  border: 1px solid #444746;
  color: #0b57d0;
  font-size: 14px;
  margin-top: 12px;
`;
const UserName = styled.span`
  color: #222;
  font-weight: 600;
  font-size: 14px;
  text-wrap: nowrap;
`;
const UserEmail = styled.span`
  color: #222;
  font-weight: 400;
  font-size: 14px;
`;
const UserInfoWrap = styled.div`
  width: calc(100% - 56px);
`;

const UserProfile = ({ user, plan }) => {
  return (
    <div className="flex flex-col items-center w-full">
      <div className="flex w-full gap-8">
        <div>
          <Avatar
            showFallback
            src={user.profileImage}
            name={user.name}
            fallback={getNameInitials(user.name)}
            className="w-[48px] h-[48px] text-large bg-navyBlue text-white"
          />
        </div>
        <UserInfoWrap className="flex flex-col text-left justify-center">
          <UserName
            aria-label="user-name-profile-dropdown"
            className="text-ellipsis overflow-hidden max-w-[208px]"
          >
            {user.name}
          </UserName>
          <UserEmail
            aria-label="user-email-profile-dropdown"
            className="text-ellipsis overflow-hidden max-w-[208px]"
          >
            {user.email}
          </UserEmail>
        </UserInfoWrap>
      </div>
      <RenderIf isTrue={plan !== UNIVERSITYPLAN}>
        <ActivePlan aria-label="active-plan-profile-dropdown">
          Active Plan: {capitalizeFirstLetter(user.planType)}
        </ActivePlan>
      </RenderIf>
    </div>
  );
};

export default UserProfile;
